type EmployeeSegment = {
  name: string
  input?: { team_id?: string; role_id?: string } | Record<string, never>
}

const isEmployeeSegment = (segment: unknown): segment is EmployeeSegment => {
  return typeof segment === 'object' && segment !== null && 'name' in segment
}

export const mapEmployeeSegments = (segments: unknown) => {
  if (!segments || !Array.isArray(segments)) {
    return undefined
  }

  const mapped = segments.filter(isEmployeeSegment).map((segment) => {
    if (segment.name === 'anyone_in_team' || segment.name === 'team_leads') {
      const teamId =
        typeof segment.input === 'object' && segment.input !== null && 'team_id' in segment.input
          ? String(segment.input.team_id)
          : null

      if (teamId) {
        if (segment.name === 'anyone_in_team') {
          return {
            name: 'anyone_in_team' as const,
            input: { team_id: teamId },
          }
        }
        return {
          name: 'team_leads' as const,
          input: { team_id: teamId },
        }
      }
    } else if (segment.name === 'employee_manager') {
      return {
        name: 'employee_manager' as const,
        input: {},
      }
    } else if (segment.name === 'employee_timeoff_manager') {
      return {
        name: 'employee_timeoff_manager' as const,
        input: {},
      }
    } else if (segment.name === 'admins') {
      return {
        name: 'admins' as const,
        input: {},
      }
    } else if (segment.name === 'resource_owner') {
      return {
        name: 'resource_owner' as const,
        input: {},
      }
    } else if (segment.name === 'job_catalog_role') {
      const roleId =
        typeof segment.input === 'object' && segment.input !== null && 'role_id' in segment.input
          ? String(segment.input.role_id)
          : undefined

      if (roleId) {
        return {
          name: 'job_catalog_role' as const,
          input: { role_id: roleId },
        }
      }
    }
    return null
  })

  return mapped.filter((segment): segment is NonNullable<typeof segment> => segment !== null)
}
